import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';

interface Props {
  label?: string;
}

const LoadingSpinner: React.FC<Props> = observer(props => {
  const { label } = props;
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      width={1}
      height={1}
      p={4}
    >
      <CircularProgress />
      <Box sx={{ m: 2 }}>
        <span>{label}</span>
      </Box>
    </Box>
  );
});

export default LoadingSpinner;
